import clsx from "clsx";
import styles from "./Overlay.module.css";
const Overlay = ({ open, ...props }) => {
  return <div className={clsx(styles["overlay"], open && styles["visible"])} {...props}></div>;
};

export default Overlay;
